import type { IconSvgObject } from './types';

const ApertureIcon: IconSvgObject = [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3V9.5M16 9.5V14M16 9.5L6 4.5M11.5 7.5L2.5 13M8 21V14.5M8 14.5V10M8 14.5L18 19.5M12.5 16.5L21.5 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ApertureIcon;
